import { useEffect } from 'react'

import { useAppStore } from '@/store/useAppStore'
import { TokenGate } from '@/features/auth/TokenGate'
import { AppShell } from '@/components/layout/AppShell'
import { ParserPage } from '@/features/parser/ParserPage'
import { AutoBotPage } from '@/features/autobot/AutoBotPage'
import { Spinner } from '@/components/common/Spinner'

export function App() {
  const authed = useAppStore((s) => s.authed)
  const restoring = useAppStore((s) => s.restoring)
  const route = useAppStore((s) => s.route)
  const restoreSession = useAppStore((s) => s.restoreSession)

  // На старте — попытка восстановить сохранённую сессию (токен из localStorage, до суток).
  useEffect(() => {
    void restoreSession()
  }, [restoreSession])

  if (restoring) {
    // Не мигаем формой логина, пока проверяем сохранённый токен.
    return (
      <div className="app-shell">
        <div className="session-restore">
          <Spinner size={20} />
          <span>Восстановление сессии…</span>
        </div>
      </div>
    )
  }

  if (!authed) {
    // До авторизации показываем только токен-гейт (никаких данных без токена).
    return (
      <div className="app-shell">
        <TokenGate />
      </div>
    )
  }

  return <AppShell>{route === 'parser' ? <ParserPage /> : <AutoBotPage />}</AppShell>
}
